"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const Pagination_1 = tslib_1.__importDefault(require("@material-ui/lab/Pagination"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_native_1 = require("react-native");
exports.Pagination = (props) => {
    const { count, disabled, onChange, page, testID, style } = props, rest = tslib_1.__rest(props, ["count", "disabled", "onChange", "page", "testID", "style"]);
    const onChangeCustom = (_event, pageNum) => {
        if (onChange) {
            onChange(pageNum);
        }
    };
    return (react_1.default.createElement(Pagination_1.default, Object.assign({ color: "primary", count: count, disabled: disabled, onChange: onChangeCustom, page: page, style: react_native_1.StyleSheet.flatten(style) }, rest)));
};
exports.Pagination.defaultProps = components_1.PaginationDefaultProps;
